import {
  getContentfulAssetUrlandAlt,
  getContentfulField,
} from 'common/components';
import { useClassName } from 'common/hooks';
import React from 'react';
import './passes-and-bundles.less';
import { Intro } from './Intro/Intro';
import { Title } from './Title/Title';
import { TicketsCards } from './TicketsCards/TicketsCards';

export const PassesAndBundles = ({ venue }) => {
  const className = useClassName('PassesAndBundles');
  const mainColor = getContentfulField(venue.parkScreen?.mainColor);
  const tertiaryColor = getContentfulField(venue.parkScreen?.tertiaryColor);

  const passesAndBundlesTitle = getContentfulField(
    venue.parkScreen.passesAndBundlesTitle
  );
  const passesAndBundlesText = getContentfulField(
    venue.parkScreen.passesAndBundlesText
  );

  const passesAndBundlesWavesFields = getContentfulField(
    venue.parkScreen?.passesAndBundleWaves
  ).fields;

  const passesAndBundlesWaves = {
    desktop: getContentfulAssetUrlandAlt(passesAndBundlesWavesFields.desktop),
  };

  const petAssetFields = getContentfulField(venue.parkScreen?.pet).fields;

  const pet = {
    desktop: getContentfulAssetUrlandAlt(petAssetFields.desktop),
    tablet: getContentfulAssetUrlandAlt(petAssetFields.tablet),
    mobile: getContentfulAssetUrlandAlt(petAssetFields.mobile),
  };

  const passesAndBundlesTitleText = 'Passes & Bundles';
  const passesAndBundlesTitleDescription = getContentfulField(
    venue.parkScreen.passesAndBundlesDescription
  );

  const ticketsCardsFields = getContentfulField(
    venue.parkScreen?.ticketsCards
  ).fields;

  const ticketsCards = {
    name: getContentfulField(ticketsCardsFields.name),
    slides: getContentfulField(ticketsCardsFields.slides).map((slide) => {
      const settings = getContentfulField(slide.fields.settings);

      const priceKeyValue = settings.find(
        (setting) => getContentfulField(setting.fields.key) === 'price'
      );
      const price = priceKeyValue
        ? getContentfulField(priceKeyValue?.fields.value)
        : null;

      const oldPriceKeyValue = settings.find(
        (setting) => getContentfulField(setting.fields.key) === 'oldPrice'
      );
      const oldPrice = oldPriceKeyValue
        ? getContentfulField(oldPriceKeyValue?.fields.value)
        : null;

      const daysInfoKeyValue = settings.find(
        (setting) => getContentfulField(setting.fields.key) === 'daysInfo'
      );
      const daysInfo = daysInfoKeyValue
        ? getContentfulField(daysInfoKeyValue?.fields.richTextValue)
        : null;

      const parkScreens = settings
        .filter(
          (setting) => getContentfulField(setting.fields.key) === 'parkScreen'
        )
        .map((setting) => getContentfulField(setting.fields.value));

      const validUpToValue = settings.find(
        (setting) => getContentfulField(setting.fields.key) === 'validUpTo'
      );
      const validUpTo = validUpToValue
        ? getContentfulField(validUpToValue?.fields.value)
        : null;

      const visitsValue = settings.find(
        (setting) => getContentfulField(setting.fields.key) === 'visits'
      );
      const visits = visitsValue
        ? getContentfulField(visitsValue?.fields.value)
        : null;

      const featuredValue = settings.find(
        (setting) => getContentfulField(setting.fields.key) === 'featured'
      );

      const featured = featuredValue
        ? getContentfulField(featuredValue?.fields.value)
        : null;

      const useStartingAtValue = settings.find(
        (setting) => getContentfulField(setting.fields.key) === 'useStartingAt'
      );

      const useStartingAt = getContentfulField(
        useStartingAtValue?.fields.value
      );

      const asset = getContentfulField(slide.fields.asset);
      const assetDesktop = getContentfulAssetUrlandAlt(asset.fields.desktop);

      const linkArrayFields = getContentfulField(slide.fields.links);
      const links = linkArrayFields.map((link) => {
        return {
          label: getContentfulField(link.fields.label),
          url: getContentfulField(link.fields.url),
          type: getContentfulField(link.fields.type),
        };
      });

      return {
        asset: assetDesktop,
        name: getContentfulField(slide.fields.name),
        daysInfo,
        price,
        oldPrice,
        parkScreens,
        link: links.length > 0 ? links[0] : null,
        validUpTo,
        visits,
        featured,
        useStartingAt,
      };
    }),
  };

  return (
    <div className={className('container')}>
      <Intro
        title={passesAndBundlesTitle}
        description={passesAndBundlesText}
        pet={pet}
        waves={passesAndBundlesWaves}
        mainColor={mainColor}
        tertiaryColor={tertiaryColor}
      />
      <Title
        title={passesAndBundlesTitleText}
        description={passesAndBundlesTitleDescription}
        tertiaryColor={tertiaryColor}
        ticketsCards={ticketsCards}
      />

      <TicketsCards ticketsCards={ticketsCards} tertiaryColor={tertiaryColor} />
    </div>
  );
};
